import { useContext } from "react";
import { useSelector } from "react-redux";
import { ProjectCreationError } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  error: ProjectCreationError;
  createProject(request: Boundaries["createProject"]["request"]): void;
}

function useProjectCreation(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isProjectCreationRequestPending),
    isRequestSuccess: useSelector(selector.isProjectCreationRequestSuccess),
    isRequestFailure: useSelector(selector.isProjectCreationRequestFailure),
    error: useSelector(selector.getProjectCreationError),
    createProject: core.createProject,
  };
}

export { useProjectCreation };
